/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_SpeakerInputs */



/**
* | output |
* | --- |
* | "Open the Insert Speaker Name window" |
*
* @param {Shortcut_Keys_Desc_Insert_SpeakerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_speaker = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_SpeakerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_SpeakerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir la fenetre Inserer un nom de locuteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffnen Sie das Fenster „Lautsprechernamen einfügen“.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aprire la finestra Inserisci nome relatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Откройте окно «Вставить имя докладчика».")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abra la ventana Insertar nombre del orador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开“插入发言人姓名”窗口")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカー名の挿入ウィンドウを開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर का नाम डालें विंडो खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abra a janela Inserir Nome do Orador")
	return /** @type {LocalizedString} */ ("Open the Insert Speaker Name window")
});